module.exports = __webpack_public_path__ + "media/images/default/pages/about/3-92cd4d85175e77464b1e80cc587a55b6.jpg";